import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, withKeys as _withKeys, createBlock as _createBlock } from "vue"

import { throttle } from '@/utils/tools';
import { nextTick, Ref, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  modelValue: {
    type: [String, Number],
    default: ''
  },
},
  emits: ['valueChange', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const flag = ref(false)

const inputValue: Ref<string | number> = ref('')
const handleMethods = (val) => {
  emit('update:modelValue', val)
}

const inputRef = ref(null)
const handleClick = () => {
  flag.value = true
  inputValue.value = props.modelValue
  nextTick(() => {
    inputRef.value.focus()
    // const input = document.querySelector('.db-Click__input .el-input__inner')
    // input.focus()
  })
}

// 添加节流函数，防止回车事件和失去焦点事件同时触发
const handleInputMethods =  throttle((type) => {
  if(flag.value){
    type === 'blur' ? done() : null
    emit('valueChange', props.modelValue, done)
  }
}, 100)

const done = () => {
  flag.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (!flag.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "value__span",
        onDblclick: handleClick
      }, _toDisplayString(__props.modelValue), 33))
    : (_openBlock(), _createBlock(_component_el_input, {
        key: 1,
        ref_key: "inputRef",
        ref: inputRef,
        size: "small",
        class: "db-Click__input",
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_unref(handleInputMethods)('enter')), ["native","enter"])),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_unref(handleInputMethods)('blur'))),
        onInput: handleMethods
      }, null, 8, ["modelValue"]))
}
}

})